// @mui
import { TableRow, TableCell, Typography, Badge } from '@mui/material';
// components
import Label from '../../components/Label';
// utils
import { fKrDateKST, fKrTrackingTimeShortKST } from '../../utils/formatTime';

// ----------------------------------------------------------------------
export default function TrackingRecordTableRow({ lastId, row, onClick }) {
  const {
    id,
    start_at,
    end_at,
    modified_start_at,
    modified_end_at,
    is_manual = false,
  } = row;

  const isRunning = !end_at;
  const modified = modified_start_at && modified_end_at;
  const startDateTime = modified ? modified_start_at : start_at;
  const endDateTime = modified ? modified_end_at : end_at;
  const duration = new Date(endDateTime) - new Date(startDateTime);
  const hours = Math.floor(duration / (1000 * 60 * 60));
  const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

  return (
    <TableRow
      sx={{
        ':hover': {
          backgroundColor: 'background.neutral',
          cursor: 'pointer',
        },
        ':active': {
          backgroundColor: 'grey.300',
        },
      }}
      onClick={onClick}
    >
      <TableCell align="left" sx={{ p: 3 }}>
        <Badge
          color="error"
          variant="dot"
          invisible={lastId >= id}
        >
          <Typography variant="subtitle2" noWrap sx={{ px: 0.5 }}>
            {fKrDateKST(startDateTime)}
          </Typography>
        </Badge>
        {isRunning && (
          <Label variant="ghost" color="info" sx={{ ml: 1 }}>
            현재 근무중
          </Label>
        )}
        {is_manual && (
          <Label variant="outlined" color="primary" sx={{ ml: 1 }}>
            수동 등록함
          </Label>
        )}
      </TableCell>

      <TableCell align="center" sx={{ p: 3 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {fKrTrackingTimeShortKST(startDateTime)} ~ {isRunning ? "퇴근전" : fKrTrackingTimeShortKST(endDateTime)}
        </Typography>
      </TableCell>

      <TableCell align="left" sx={{ p: 3 }}>
        <Typography variant="subtitle2" sx={{ color: "text.secondary" }} noWrap>
          {isRunning ? "-" : hours > 0 ? `${hours}시간 ${minutes}분` : `${minutes}분`}
        </Typography>
      </TableCell>
    </TableRow>
  )
}
